// test2594
(2594 && 0);
